import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import { Settings as SettingsIcon, Logout, List } from '@mui/icons-material';
import { useAuth } from '../context/AuthContext';

const Layout: React.FC = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position="static" elevation={0}>
        <Toolbar>
          <Box
            sx={{ display: 'flex', alignItems: 'center', flexGrow: 1, cursor: 'pointer' }}
            onClick={() => navigate('/tasks')}
          >
            <Box
              component="img"
              src="/logo.png"
              alt="Logo"
              sx={{ width: 40, height: 40, mr: 2 }}
            />
            <Typography variant="h6" component="div">
              Asana Recurrence Manager
            </Typography>
          </Box>

          <Tooltip title="Taches">
            <IconButton
              color="inherit"
              onClick={() => navigate('/tasks')}
              sx={{
                bgcolor: location.pathname === '/tasks' ? 'rgba(255,255,255,0.1)' : 'transparent',
              }}
            >
              <List />
            </IconButton>
          </Tooltip>

          <Tooltip title="Parametres">
            <IconButton
              color="inherit"
              onClick={() => navigate('/settings')}
              sx={{
                bgcolor: location.pathname === '/settings' ? 'rgba(255,255,255,0.1)' : 'transparent',
              }}
            >
              <SettingsIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="Deconnexion">
            <IconButton color="inherit" onClick={handleLogout}>
              <Logout />
            </IconButton>
          </Tooltip>
        </Toolbar>
      </AppBar>

      <Box component="main" sx={{ flexGrow: 1, bgcolor: 'background.default', p: 3 }}>
        <Outlet />
      </Box>
    </Box>
  );
};

export default Layout;
